<div *ngIf="isInModal" class="{{ hasValue() ? 'text-success' : 'text-dark' }} font-size- fw-bold ">
  {{ placeHolder | translate }}
</div>
<nouislider
  *ngIf="sliderConfig"
  [config]="sliderConfig"
  class="slider slider-success w-100 mb-6"
  [formControl]="sliderControl"
></nouislider>
<hr *ngIf="isInModal" />
